import {Directive} from '@angular/core';
import {NgIfAnimateDirective} from './ng-if-animate.directive';

@Directive({
  selector: '[appNgIfExpand]',
  hostDirectives: [
    {
      directive: NgIfAnimateDirective,
      inputs: ['appNgIfAnimate: appNgIfExpand']
    }
  ]
})
export class NgIfExpandDirective {
  constructor(animateDirective: NgIfAnimateDirective) {
    animateDirective.appNgIfAnimateClass.set('ace-will-expand-collapse');
    animateDirective.appNgIfAnimateClassOnEnter.set('ace-expand');
    animateDirective.appNgIfAnimateClassOnLeave.set('ace-collapse');
  }
}